import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { startCase } from 'lodash';
import { Schema, ValidationError } from 'yup';

export function createValidatorFromSchema(schema: Schema, config: any): ValidatorFn {
  return (group: AbstractControl | FormGroup) => {
    const valErrors: ValidationErrors = {};
    clearFormErrors(group as FormGroup);
    try {
      schema.validateSync(group.value, {
        abortEarly: false,
        context: { config },
      });
    } catch (errors: any) {
      errors?.inner?.forEach((error: ValidationError) => {
        if (!error.path) return;

        valErrors[error.path] = cleanMessage(error.path, error.message);

        const control = group?.get(error.path);

        if (error.path.includes('[')) {
          // This is really hacky and will only work audi-form.component. Need to alter getControl() to search through a FormArray
          const index = +error.path.substring(error.path.lastIndexOf('[') + 1, error.path.lastIndexOf(']'));
          const arrayName = error.path.split('[')[0];
          const controlName = error.path.split('].')[1];

          const newControl = group.get(arrayName) as FormArray;
          if (newControl) {
            const controlInArray = newControl.at(index);
            controlInArray.get(controlName)?.setErrors({ [error.path]: valErrors[error.path] });
            controlInArray.get(controlName)?.setErrors({ [controlName]: valErrors[error.path] });
          }
        } else {
          control?.setErrors({ [error.path]: valErrors[error.path] });
        }
      });

      return valErrors;
    }

    return null;
  };
}

function clearFormErrors(group: FormGroup) {
  for (const key in group?.controls) {
    if (key) {
      const control = group?.get(key);
      if (control?.errors) {
        control?.setErrors(null);
      }
      if ((control as FormGroup)?.controls) {
        clearFormErrors(control as FormGroup);
      }
    }
  }
}

function cleanMessage(path: string, message: string) {
  const pathArray = path.split('.');
  const controlName = pathArray.slice(-1)[0];

  return message.replace(path, startCase(controlName));
}
